// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';

export function ConditionalWrapperComponent({ condition, children }) {
  if (!condition) {
    return null;
  }
  return children;
}

ConditionalWrapperComponent.propTypes = {
  condition: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  children: PropTypes.element,
};

export default ConditionalWrapperComponent;



// WEBPACK FOOTER //
// ./src/components/ConditionalWrapper/ConditionalWrapper.js